import {
    STORAGE_ADMIN_COLOR,
    STORAGE_ADMIN_THEME,
    normalizeAdminColorPreset,
    normalizeAdminThemeMode,
} from '../constants/adminAppearancePalettes.js';

function resolveDark(themeMode) {
    if (themeMode === 'dark') {
        return true;
    }
    if (themeMode === 'light') {
        return false;
    }
    if (typeof window === 'undefined' || !window.matchMedia) {
        return false;
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

/**
 * 将配色与深浅应用到 document.documentElement（TDesign 使用 theme-mode + .dark）
 */
export function applyAdminAppearanceDom(colorPreset, themeMode) {
    if (typeof document === 'undefined') {
        return;
    }
    const root = document.documentElement;
    const color = normalizeAdminColorPreset(colorPreset);
    const mode = normalizeAdminThemeMode(themeMode);
    root.setAttribute('data-admin-color', color);
    const dark = resolveDark(mode);
    if (dark) {
        root.setAttribute('theme-mode', 'dark');
        root.classList.add('dark');
    } else {
        root.setAttribute('theme-mode', 'light');
        root.classList.remove('dark');
    }
}

export function applyAdminAppearanceFromStorage() {
    try {
        const color = normalizeAdminColorPreset(
            typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_ADMIN_COLOR) : null,
        );
        const theme = normalizeAdminThemeMode(
            typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_ADMIN_THEME) : null,
        );
        applyAdminAppearanceDom(color, theme);
    } catch (e) {
        console.warn('applyAdminAppearanceFromStorage', e);
        applyAdminAppearanceDom('default', 'system');
    }
}

function bindSystemThemeListenerOnce() {
    if (typeof window === 'undefined' || window.__adminAppearanceMqlBound) {
        return;
    }
    window.__adminAppearanceMqlBound = true;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => {
        try {
            const mode = normalizeAdminThemeMode(localStorage.getItem(STORAGE_ADMIN_THEME));
            if (mode !== 'system') {
                return;
            }
            const color = normalizeAdminColorPreset(localStorage.getItem(STORAGE_ADMIN_COLOR));
            applyAdminAppearanceDom(color, 'system');
        } catch (e) {
            console.warn('admin appearance prefers-color-scheme', e);
        }
    };
    mq.addEventListener('change', onChange);
}

/**
 * 首屏同步：在 createApp 之前调用；并绑定「跟随系统」时的媒体查询。
 */
export function syncAdminAppearanceFromStorage() {
    applyAdminAppearanceFromStorage();
    bindSystemThemeListenerOnce();
}

export function persistAdminColorPreset(id) {
    const v = normalizeAdminColorPreset(id);
    try {
        localStorage.setItem(STORAGE_ADMIN_COLOR, v);
    } catch (e) {
        console.warn('persistAdminColorPreset', e);
    }
    applyAdminAppearanceFromStorage();
}

export function persistAdminThemeMode(mode) {
    const v = normalizeAdminThemeMode(mode);
    try {
        localStorage.setItem(STORAGE_ADMIN_THEME, v);
    } catch (e) {
        console.warn('persistAdminThemeMode', e);
    }
    applyAdminAppearanceFromStorage();
}
